
  <img [src]="dataUrl" [class]="cssClasses" [style.width]="width" [style.height]="height" />
